var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Keycloak from "keycloak-js";
import { appDataMockup } from './mockup';
import { Util } from "./util";
import { DomHelper, iconClosedGroup, iconOpenGroup } from "./domHelper";
import { getBackendData, sendBackendData } from "./xhrbackend";
import { API_URL, DEBUG, DEFAULT_PREFS, KEYCLOAK } from "./config";
import { appTimetableRender, appTimetableUploadRender } from "./appTimetable";
import { getAppCardNode } from "./appCardDefault";
import { appVoucher } from "./appVoucher";
import { appRelatedResponsiblitiesRender } from "./appRelatedResponsiblities";
import { appNestedGroupRender } from "./appNestedGroup";
import { appSchoolAdminRender } from "./appSchoolAdmin";
import { appSchoolAdminInviteRender } from "./appSchoolAdminInvite";
import { appKiDialog, appKiFlex, appKiSimple, appKiSummarize, appKiDocument } from "./appKiDialog";
import { appDeskAppAdmin, appDeskMessageStatistic, appInpsersonate, appLDAPQuery } from "./appDeskAdmin";
import { appWebshop } from "./appWebshop";
import { publicRouter } from "./publicRouter";
import { appUserInvitation } from "./appUserInvitation";
import { appDeskPupilGrades } from "./appSchoolAdminGrade";
import { appDeskMedpro } from "./appMedpro";
import { appRocketAppAdmin } from "./appappRocketAppAdmin";
import { appLaps } from "./appLaps";
import { openProfile } from "./appProfile";
import { appZbxSync } from "./appZbxSync";
import { appOfficeDbAdminRender } from "./appOfficeDbAdmin";
import { appDevice } from "./appDevice";
import { appOCR } from "./appOCR";
import { appDeskRagAdmin } from "./appRagAdmin";
import { appTOTP } from "./appTOTP";
let username;
let userLogoutTriggered = false;
let wlanList;
let bearerToken;
let userinfo;
let userPreferences = {
    theme: "",
    favorites: [],
    logInteraction: false
};
const keycloakConfig = {
    url: KEYCLOAK.url,
    realm: KEYCLOAK.realm,
    clientId: KEYCLOAK.clientId,
};
export let sessionid = Util.generateRandomDomId();
export let logEvents = false;
const store = {
    nameKeyUser: new Map(),
    nameKeyOtObject: new Map,
    lastOrder: {},
    lastSearchString: "",
    addressQueryResult: [],
    user: {
        username: "",
        userid: -1
    },
    phoneStore: {
        enduser: '',
        phoneuser: ''
    },
    bearerToken: '',
    shopUserId: 0,
    lastOrderFetch: null,
    startDate: null
};
const keycloak = new Keycloak(keycloakConfig);
function init() {
    if (DEBUG)
        console.log("init");
    const url = new URL(window.location.href);
    const path = url.pathname;
    if (DEBUG)
        console.log("path", path);
    if (path === '/public') {
        document.addEventListener("DOMContentLoaded", () => {
            publicRouter(url);
        });
        return;
    }
    if ((window.location.host === "desk.localhost" || window.location.host === "apps.localhost" || window.location.host === "deskpes.localhost" || window.location.host === "admpesapps.localhost") && DEBUG) {
        if (DEBUG)
            console.log("Preview mode", API_URL);
        username = (window.location.host === "desk.localhost" || window.location.host === "apps.localhost") ? "mackt" : "pessingerm02";
        logEvents = true;
        document.addEventListener("DOMContentLoaded", () => {
            getUserAppCollection(username, render);
        });
        if (logEvents)
            Util.logMessage(bearerToken, sessionid, "desk", "login", "null");
        return;
    }
    keycloak.init({}).then((authenticated) => {
        var _a, _b;
        if (authenticated) {
            if (DEBUG)
                console.log("User is authenticated", keycloak.tokenParsed);
            username = (_a = keycloak.tokenParsed) === null || _a === void 0 ? void 0 : _a.preferred_username;
            bearerToken = keycloak.token ? keycloak.token : "";
            getUserAppCollection((_b = keycloak.tokenParsed) === null || _b === void 0 ? void 0 : _b.preferred_username, render);
        }
        else {
            keycloak.login().then((authenticated) => {
                var _a, _b;
                if (DEBUG)
                    console.log("Login result", authenticated);
                userinfo = keycloak.loadUserInfo();
                if (DEBUG)
                    console.log("Userinfo", userinfo);
                username = (_a = keycloak.tokenParsed) === null || _a === void 0 ? void 0 : _a.preferred_username;
                getUserAppCollection((_b = keycloak.tokenParsed) === null || _b === void 0 ? void 0 : _b.preferred_username, render);
            }).catch((error) => {
                console.log("Login failed", error);
            });
        }
    }).catch((error) => {
        console.log("Init error", error);
    });
}
function login() {
    if (DEBUG)
        console.log("url", window.location.host);
    if (DEBUG)
        console.log("-->login", userLogoutTriggered);
    keycloak.login().then((authenticated) => {
        if (DEBUG)
            console.log("Login result", authenticated);
        userinfo = keycloak.loadUserInfo();
        if (DEBUG)
            console.log("Userinfo", userinfo);
    }).catch((error) => {
        console.log("Login failed", error);
    });
}
function logout() {
    if (DEBUG)
        console.log("-->logout");
    userLogoutTriggered = true;
    keycloak.logout({
        redirectUri: "./goodbye.html"
    }).then((authenticated) => {
        console.log("Logout result", authenticated);
    }).catch((error) => {
        console.log("Logout failed", error);
    });
}
function safeUserPreferences(username, value) {
    if (DEBUG)
        console.log("-->safeUserPreferences", username, userPreferences, value);
    try {
        localStorage.setItem("preferences", JSON.stringify(userPreferences));
    }
    catch (e) {
        console.error(e);
    }
}
function addGroupFavorites(parentNode, userInfo) {
    var _a, _b, _c, _d;
    const sectionHeader = DomHelper.appendNode(parentNode, "section", ['rudi-app-group-header'], []);
    const h1 = DomHelper.appendNode(sectionHeader, 'h1', [], []);
    let iconClasses = ['fa-solid'];
    iconClasses.push((((_b = (_a = userInfo.odDeskPreferences) === null || _a === void 0 ? void 0 : _a.favorites) === null || _b === void 0 ? void 0 : _b.length) == 0) ? iconClosedGroup : iconOpenGroup);
    DomHelper.appendNode(h1, 'i', iconClasses, [{ attr: "id", value: "rudi-favorites_icon" }]);
    DomHelper.appendNode(h1, 'a', ['rudi-id'], [{ attr: "id", value: "rudi-favorites_link" }], "Favoriten");
    let iconClassesSection = ['rudi-app-group'];
    if (((_d = (_c = userInfo.odDeskPreferences) === null || _c === void 0 ? void 0 : _c.favorites) === null || _d === void 0 ? void 0 : _d.length) == 0)
        iconClassesSection.push('disabled');
    const sectionChildrenHeader = DomHelper.appendNode(sectionHeader, 'section', iconClassesSection, [{
            attr: "id",
            value: "rudi-favorites_section"
        }]);
    return [sectionHeader, sectionChildrenHeader];
}
function setTheme(selectedTheme, userPreferences, username, skipSave = false) {
    const themeLink = document.getElementById('rudi-body');
    if (themeLink) {
        for (let classItem of themeLink.classList) {
            themeLink.classList.remove(classItem);
        }
        themeLink.classList.add(selectedTheme);
    }
    userPreferences.theme = selectedTheme;
    if (!skipSave) {
        Util.saveUserPreferences(username, userPreferences, bearerToken);
    }
}
function enableThemeSwitcher() {
    const themeButton = document.getElementById("rudi-btn-theme");
    const themeDropdown = document.getElementById("rudi-theme-dropdown");
    if (themeButton) {
        themeButton.addEventListener('click', function () {
            if (themeDropdown)
                themeDropdown.classList.toggle('disabled');
            const profileName = document.getElementById("rudi-btn-sap-profile");
            if (profileName)
                profileName.classList.toggle('disabled');
            const themeSelector = document.getElementById("rudi-theme-selector");
            if (themeSelector) {
                themeSelector.addEventListener('change', function () {
                    const selectedTheme = themeSelector.value;
                    setTheme(selectedTheme, userPreferences, username);
                    const themeDropdown = document.getElementById("rudi-theme-dropdown");
                    const profileName = document.getElementById("rudi-btn-sap-profile");
                    if (themeDropdown)
                        themeDropdown.classList.toggle('disabled');
                    if (profileName)
                        profileName.classList.toggle('disabled');
                });
            }
        });
    }
}
function renderAppByType(app, currentNetwork, appendSection, userResponse, standalone = false) {
    if (app.odAppType === "-role" || app.odAppType === "persona" || app.odAppType === "template") {
    }
    else if (app.odAppType === "wlan-voucher") {
        let networkRestriction = isNetworkRestricted(app, currentNetwork, standalone);
        appVoucher(username, bearerToken, appendSection, app, userResponse, networkRestriction);
    }
    else if (app.odAppType === "bbb-join") {
        appBbbJoinRender(appendSection, app);
    }
    else if (app.odAppType === "bv-link") {
        appBvLinkRender(appendSection, app, currentNetwork);
    }
    else if (app.odAppType === "schuelerausweis") {
        appSchuelerausweisRender(appendSection, app, userResponse);
    }
    else if (app.odAppType === "qrcode") {
        appQRCodeRender(appendSection, app, userResponse);
    }
    else if (app.odAppType === "asp") {
        appRelatedResponsiblitiesRender(username, bearerToken, userResponse.odDeskPreferences, appendSection, app);
    }
    else if (app.odAppType === "timetable") {
        appTimetableRender(username, bearerToken, appendSection, app, userResponse);
    }
    else if (app.odAppType === "timetable-upload") {
        appTimetableUploadRender(username, bearerToken, appendSection, app, userResponse);
    }
    else if (app.odAppType === "schooladmin") {
        appSchoolAdminRender(username, bearerToken, appendSection, app, userResponse);
    }
    else if (app.odAppType === "schooladmininvite") {
        appSchoolAdminInviteRender(username, bearerToken, appendSection, app, userResponse);
    }
    else if (app.odAppType === "ki-dialog") {
        appKiDialog(username, bearerToken, appendSection, app, userResponse);
    }
    else if (app.odAppType === "ki-sum") {
        appKiSummarize(username, bearerToken, appendSection, app, userResponse);
    }
    else if (app.odAppType === "ki-document") {
        appKiDocument(username, bearerToken, appendSection, app, userResponse);
    }
    else if (app.odAppType === "ki-simple") {
        appKiSimple(username, bearerToken, appendSection, app, userResponse);
    }
    else if (app.odAppType === "ki-flex") {
        appKiFlex(username, bearerToken, appendSection, app, userResponse);
    }
    else if (app.odAppType === "webshop") {
        appWebshop(store, username, bearerToken, userResponse.odDeskPreferences, appendSection, app, userResponse);
    }
    else if (app.odAppType === "appadmin") {
        appDeskAppAdmin(username, bearerToken, appendSection, app, userResponse);
    }
    else if (app.odAppType === "appragtopic") {
        appDeskRagAdmin(username, bearerToken, appendSection, app, userResponse);
    }
    else if (app.odAppType === "message-statistic") {
        appDeskMessageStatistic(username, bearerToken, appendSection, app, userResponse);
    }
    else if (app.odAppType === "inpersonate") {
        appInpsersonate(username, bearerToken, appendSection, app, userResponse);
    }
    else if (app.odAppType === "grade") {
        appDeskPupilGrades(username, bearerToken, appendSection, app, userResponse);
    }
    else if (app.odAppType === "medpro") {
        appDeskMedpro(username, bearerToken, appendSection, app, userResponse);
    }
    else if (app.odAppType === "ldapquery") {
        appLDAPQuery(username, bearerToken, appendSection, app, userResponse);
    }
    else if (app.odAppType === "user-invitation") {
        appUserInvitation(store, username, bearerToken, appendSection, app, userResponse);
    }
    else if (app.odAppType === "rocketadmin") {
        appRocketAppAdmin(store, username, bearerToken, appendSection, app, userResponse);
    }
    else if (app.odAppType === "profil-rd") {
        openProfile(appendSection, appendSection, appendSection, username, bearerToken, 'rd', userResponse, standalone);
    }
    else if (app.odAppType === "laps") {
        appLaps(store, username, bearerToken, appendSection, app, userResponse);
    }
    else if (app.odAppType === "ocr") {
        appOCR(store, username, bearerToken, appendSection, app, userResponse);
    }
    else if (app.odAppType === "device") {
        appDevice(store, username, bearerToken, appendSection, app, userResponse);
    }
    else if (app.odAppType === "zbxsync") {
        appZbxSync(store, username, bearerToken, appendSection, app, userResponse);
    }
    else if (app.odAppType === "officedb") {
        appOfficeDbAdminRender(store, username, bearerToken, appendSection, app, userResponse);
    }
    else if (app.odAppType === "apptotp") {
        appTOTP(username, bearerToken, appendSection, app, userResponse);
    }
    else {
        renderApp(appendSection, app, currentNetwork, userResponse);
    }
}
function renderAppGroup(userResponse, parent, appGroup, nodeFavoriteHeadline, nodeFavoriteChildSection, currentNetwork) {
    var _a;
    const sectionHeader = DomHelper.appendNode(parent, "section", ['rudi-app-group-header'], []);
    const h1 = DomHelper.appendNode(sectionHeader, 'h1', [], []);
    let iconClasses = ['fa-solid'];
    iconClasses.push((appGroup.odAppCollapsed) ? iconClosedGroup : iconOpenGroup);
    DomHelper.appendNode(h1, 'i', iconClasses, [{ attr: "id", value: appGroup.cn + "_icon" }]);
    DomHelper.appendNode(h1, 'a', ['rudi-id'], [{ attr: "id", value: appGroup.cn }], appGroup.odAppTitle);
    let iconClassesSection = ['rudi-app-group'];
    if (appGroup.odAppCollapsed)
        iconClassesSection.push('disabled');
    if (!userResponse.odDeskPreferences)
        userResponse.odDeskPreferences = DEFAULT_PREFS;
    const section = DomHelper.appendNode(sectionHeader, 'section', iconClassesSection, [{
            attr: "id",
            value: appGroup.cn + "_section"
        }]);
    for (let app of appGroup.children.sort((a, b) => a.odAppSortOrder - b.odAppSortOrder)) {
        let appendSection = ((_a = userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.favorites) === null || _a === void 0 ? void 0 : _a.indexOf(app.dn)) >= 0 ? nodeFavoriteChildSection : section;
        renderAppByType(app, currentNetwork, appendSection, userResponse);
    }
}
function renderNestedAppGroup(username, userResponse, appGroup, nodeFavoriteHeadline, nodeFavoriteChildSection, currentNetwork) {
    if (DEBUG)
        console.log("-->renderNestedAppGroup", appGroup.odAppParent);
    const parentCN = Util.getCNfromParentDN(appGroup.odAppParent);
    if (DEBUG)
        console.log("-->renderNestedAppGroup", parentCN);
    const sectionNode = document.getElementById(`${parentCN}_section`);
    if (sectionNode) {
        if (DEBUG)
            console.log("SectionNode found");
        appNestedGroupRender(username, sectionNode, appGroup, userResponse, bearerToken, isNetworkRestricted(appGroup, currentNetwork));
    }
    else {
        if (DEBUG)
            console.error("SectionNode not found");
    }
}
function renderAppGroupNavigation(appGroup) {
    return "<a href='#" + appGroup.cn + "'>" + appGroup.odAppTitle + "</a>";
}
function addToggleGroupEvent(identifier) {
    let DEBUG = true;
    if (DEBUG)
        console.log("-->addToggleGroupEvent");
    const nodeListOf = document.querySelectorAll(identifier);
    nodeListOf.forEach((element) => {
        if (DEBUG)
            console.log("-->Element", element.id);
        const contentID = element.id;
        const icon = document.getElementById(contentID.replace("_section", "_icon"));
        if (DEBUG)
            console.log("-->Icon", icon === null || icon === void 0 ? void 0 : icon.id);
        if (icon) {
            if (DEBUG)
                console.log("-->Icon add Eventlistener", icon === null || icon === void 0 ? void 0 : icon.id);
            icon.addEventListener('click', () => __awaiter(this, void 0, void 0, function* () {
                const visibleState = (icon && icon.classList.contains(iconOpenGroup)) ? true : false;
                if (DEBUG)
                    console.log("Content " + contentID + " is visible: ", visibleState);
                if (visibleState) {
                    icon.classList.remove(iconOpenGroup);
                    icon.classList.add(iconClosedGroup);
                    element.classList.add("disabled");
                }
                else {
                    icon.classList.add(iconOpenGroup);
                    icon.classList.remove(iconClosedGroup);
                    element.classList.remove("disabled");
                }
                safeUserPreferences(username, { app: contentID, state: !visibleState });
            }));
        }
    });
}
function appPupilPassToggle(userData) {
    if (DEBUG)
        console.log("-->appPupilPassToggle", userData);
    let wrapper = document.getElementById("rudi-profile-wrapper");
    if (wrapper != null) {
        wrapper.classList.remove("disabled");
        appPassPupilRender(wrapper, userData);
    }
}
function renderApp(parentNode, app, currentNetwork, myJSON) {
    const cardNode = getAppCardNode(parentNode, app, username, userPreferences, bearerToken, isNetworkRestricted(app, currentNetwork), [], myJSON);
}
export function getUserAppCollection(username, callback) {
    let request = new XMLHttpRequest();
    request.open("GET", API_URL + "/users/" + username);
    request.setRequestHeader('Accept', 'application/xml');
    request.setRequestHeader('Authorization', 'Bearer ' + keycloak.token);
    request.addEventListener('load', callback);
    request.send();
}
function appBbbJoinRender(parentNode, app) {
    if (DEBUG)
        console.log("-->appBbbJoinRender");
    const cardNode = getAppCardNode(parentNode, app, username, userPreferences, bearerToken, false, []);
    let injectNodes = cardNode.getElementsByClassName('rudi-app-inject');
    const injectNode = injectNodes.item(0);
    if (injectNode) {
        injectNode.classList.remove('rudi-app-inject');
        injectNode.classList.remove('disabled');
        injectNode.classList.add('rudi-app-interaction');
        injectNode.setAttribute("id", 'rudi-bbb-join');
        const formNode = DomHelper.appendNode(injectNode, 'form', [], [{ attr: "action", value: "https://core.open-diakonie.de/SDW/public/bbb/index.jsp" }]);
        const inputNode = DomHelper.appendInputText(formNode, 'rudi-bbb-form', ['rudi-inline-icon'], [], 'raum', '', '', [{ attr: "pattern", value: "[0-9]+" }, { attr: "placeholder", value: "Raumnummer" }]);
        const btnNode = DomHelper.appendNodeAsSibling(inputNode, 'button', ['btn', 'btn-primary'], [{
                attr: "type",
                value: "submit"
            }]);
        DomHelper.appendNode(btnNode, 'i', ['fa-light', 'fa-paper-plane']);
    }
    else {
        console.log("Couldn't get Element to add Profile content");
    }
}
function isNetworkRestricted(app, currentNetwork, standalone = false) {
    let appConfig;
    try {
        appConfig = JSON.parse(app.odAppConfig);
    }
    catch (e) {
        return false;
    }
    let networkRestriction = false;
    if (standalone) {
        return false;
    }
    if (appConfig != null && appConfig.requirenetwork) {
        networkRestriction = true;
        for (let item of appConfig.requirenetwork) {
            if (item === currentNetwork)
                networkRestriction = false;
        }
    }
    return networkRestriction;
}
function appBvLinkRender(parentNode, app, currentNetwork) {
    if (DEBUG)
        console.log("-->appBvLinkRender");
    const additionalClassList = [];
    let networkRestriction = isNetworkRestricted(app, currentNetwork);
    const cardNode = getAppCardNode(parentNode, app, username, userPreferences, bearerToken, networkRestriction, additionalClassList);
    const link = cardNode.getAttribute("href");
    if (!networkRestriction) {
        cardNode.addEventListener('click', (event) => {
            event.preventDefault();
            getBackendData(username, "/users/bvActivate/", "GET", "application/json", bearerToken, (result) => {
                appBvProcessResult(link, result);
            });
        });
    }
}
function appSchuelerausweisRender(parentNode, app, userResponse) {
    if (DEBUG)
        console.log("-->appSchuelerausweisRender");
    const additionalClassList = [];
    const cardNode = getAppCardNode(parentNode, app, username, userPreferences, bearerToken, false, additionalClassList, null, (event) => {
        appPupilPassToggle(userResponse);
    });
}
function appQRCodeRender(parentNode, app, userResponse) {
    if (DEBUG)
        console.log("-->appQRCodeRender");
    const additionalClassList = [];
    const cardNode = getAppCardNode(parentNode, app, username, userPreferences, bearerToken, false, additionalClassList);
    let injectNodes = cardNode.getElementsByClassName('rudi-app-inject');
    const injectNode = injectNodes.item(0);
    if (injectNode) {
        injectNode.classList.remove('rudi-app-inject');
        injectNode.classList.remove('disabled');
        injectNode.classList.add('rudi-app-interaction');
        injectNode.setAttribute("id", 'rudi-qrcode');
        const inputNode = DomHelper.appendInputText(injectNode, 'rudi-qr-form', ['rudi-inline-icon'], [], 'uri', '', '', []);
        const btnNode = DomHelper.appendNodeAsSibling(inputNode, 'button', ['btn', 'btn-primary'], []);
        DomHelper.appendNode(btnNode, 'i', ['fa-light', 'fa-paper-plane'], []);
        btnNode.addEventListener('click', (event) => {
            const qrCodeValue = inputNode.value;
            let appOpen = false;
            if (!cardNode.classList.contains('rudi-max-height')) {
                const imgNode = document.getElementById('qrcode-img');
                if (imgNode)
                    imgNode.remove();
                const msgNode = document.getElementById('qrcode-msg');
                if (msgNode)
                    msgNode.remove();
                appOpen = true;
            }
            if (qrCodeValue) {
                getBackendData('', `/public/qr/?uri=${encodeURIComponent(qrCodeValue)}`, "GET", "application/json", bearerToken, (result) => {
                    const response = JSON.parse(result.target.response);
                    cardNode.classList.remove('rudi-max-height');
                    const imgList = injectNode.querySelectorAll('img');
                    if (imgList) {
                        for (const img of imgList) {
                            img.remove();
                        }
                    }
                    const imgNode = DomHelper.appendNode(injectNode, 'img', ['img-fluid'], [{ attr: "src", value: response.qrcode }, { attr: 'id', value: 'qrcode-img' }]);
                    const msgNode = DomHelper.appendNode(injectNode, 'p', [], [{ attr: 'id', value: 'qrcode-msg' }], "Mit einem Klick auf den QR-Code können Sie diesen als Bild herunterladen.");
                    imgNode.addEventListener('click', (event) => {
                        const a = document.createElement('a');
                        a.href = imgNode.src;
                        a.download = 'qr-code.png';
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                    });
                    if (!appOpen)
                        DomHelper.appendCloseSection(cardNode, (event) => {
                            cardNode.classList.add('rudi-max-height');
                            const imgNode = document.getElementById('qrcode-img');
                            if (imgNode)
                                imgNode.remove();
                            const msgNode = document.getElementById('qrcode-msg');
                            if (msgNode)
                                msgNode.remove();
                            DomHelper.removeCloseSection(cardNode);
                        });
                });
            }
        });
    }
    else {
        console.log("Couldn't get Element to add content");
    }
}
export function appBvProcessResult(url, response) {
    let myJSON;
    if (response != null) {
        myJSON = JSON.parse(response.target.response);
        wlanList = myJSON;
    }
    if (myJSON.data.d.ReturnValue == "OK" && url) {
        window.open(url, '_blank');
    }
    else {
        console.error("Could not activate user in Backend");
    }
}
function appKiToggle() {
    const parentNode = document.getElementById('rudi-btn-ki-brain');
    parentNode === null || parentNode === void 0 ? void 0 : parentNode.classList.add("ki-aktiv");
}
function appPassPupilRender(parent, userData) {
    if (DEBUG)
        console.log("-->appPassPupilRender", userData);
    const passNode = DomHelper.appendNode(parent, "div", ["card"], [{ attr: "id", value: "rudi-ausweis" }]);
    let pupil;
    if (userData.pupil) {
        pupil = userData.pupil;
        pupil.givenName = userData.name;
        pupil.sn = userData.surname;
    }
    else {
        pupil = {
            cn: "default", dn: "default", givenName: "Hermine", sn: "Granger",
            odDateOfBirth: 123123123,
            odCity: "Schwarzenbruck",
            odPLZ: "90592",
            valid_to: new Date().toISOString(),
            schuelerausweisqr: "   data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIQAAACECAYAAABRRIOnAAAAAklEQVR4AewaftIAAANtSURBVO3BQY5jBxYDweSD7n/lHC+84OoDglTl7gEj4j+Y+dcxU46ZcsyUY6YcM+WYKcdMOWbKMVOOmXLMlGOmHDPlmCnHTHnxoST8JpWWhKbyJAnfpPIkCb9J5RPHTDlmyjFTXnyZyjcl4SeptCT8JJVvSsI3HTPlmCnHTHnxw5LwDpVPJKGpNJVPqHxTEt6h8pOOmXLMlGOmvPjLqTxJQlN5otKS0JLwROVvdsyUY6YcM+XFXy4Jn0jCE5WWhKby/+SYKcdMOWbKix+m8pNUPqHSktCS0FRaEprKO1T+JMdMOWbKMVNefFkSflMSmkpLQlNpSWgqLQnflIQ/2TFTjplyzJQXH1L5L6m8Iwm/SeVvcsyUY6YcM+XFh5LQVJ4k4SepNJUnSWhJ+EQSmsqTJDSVloR3qHzimCnHTDlmyosvS8I7VFoSmsqTJLQkNJWWhKbyJAktCU3lHUn4JpVvOmbKMVOOmfLiQyotCU9Unqi0JDSVJyq/KQlNpSWhqTxJwhOVloSm8oljphwz5ZgpL36YypMkNJWm0pLQVFoSfpLKT1JpSfhNx0w5ZsoxU158mUpLwieS0FSeqLQkNJUnSXiShCcqT5LwDpXfdMyUY6YcMyX+gw8k4SeptCQ0lU8koak8ScITlXckoak8SUJT+aZjphwz5ZgpL/5wSfhJKk+S8ETlHUloKi0J70hCU/nEMVOOmXLMlBdfptKS0FQ+kYSWhKbSktBUWhLeodKS8A6VloR3qPykY6YcM+WYKS/+MEl4h8oTlZaEJyo/KQl/smOmHDPlmCnxH/zFktBUWhKeqHwiCU3lHUn4JpVPHDPlmCnHTHnxoST8JpUnSXii0pLwDpV3JKGpPFFpSWgqLQnfdMyUY6YcM+XFl6l8UxI+odKS0FRaEppKS8I7VN6RhKbym46ZcsyUY6a8+GFJeIfKNyXhNyXhb3bMlGOmHDPlxf8ZlZaEptKS8A6VloR3qHwiCT/pmCnHTDlmyou/nEpLQlNpSWgqLQlPktBUPpGEpvJfOmbKMVOOmfLih6n8JpV3JOGbkvBE5UkS/kvHTDlmyjFTXnxZEn5TEn6TSktCU3mHSktCU3mShG86ZsoxU46ZEv/BzL+OmXLMlGOmHDPlmCnHTDlmyjFTjplyzJRjphwz5Zgpx0w5Zsr/AD+lbSlGqHaxAAAAAElFTkSuQmCC"
        };
    }
    DomHelper.appendNode(passNode, 'img', ['card-img-top'], [{ attr: "src", value: "../img/rum_logo_text.svg" },
        { attr: "alt", value: "Rummelsberger Diakonie Logo" }]);
    const cardBody = DomHelper.appendNode(passNode, "div", ['card-body']);
    DomHelper.appendNode(cardBody, 'h5', ['card-title'], [], "Schülerausweis");
    DomHelper.appendNode(cardBody, 'p', ['card-text'], [], pupil.schoolname);
    const cardList = DomHelper.appendNode(passNode, "ul", ['list-group', 'list-group-flush']);
    DomHelper.appendNode(cardList, 'li', ['list-group-item'], [], pupil.givenName + " " + pupil.sn);
    DomHelper.appendNode(cardList, 'li', ['list-group-item'], [], "Geb.: " + Util.unixTimestamp2DateString(Number(pupil.odDateOfBirth)));
    DomHelper.appendNode(cardList, 'li', ['list-group-item'], [], "Wohnort: " + pupil.odCity + " " + pupil.odPLZ);
    DomHelper.appendNode(cardList, 'li', ['list-group-item'], [], "Gültig bis: " + Util.isoString2DateString(pupil.valid_to));
    const cardBody2 = DomHelper.appendNode(passNode, "div", ['card-body']);
    DomHelper.appendNode(cardBody2, 'img', [], [{
            attr: "src",
            value: pupil.schuelerausweisqr
        }]);
    DomHelper.appendNode(cardBody2, 'p', ['card-text'], [], "Zur Verifikation scannen Sie bitte den QR-Code");
    passNode.scrollIntoView({ behavior: "smooth", block: "start" });
}
function enableLogoutButton() {
    let domContent = document.getElementById("rudi-btn-logout");
    domContent === null || domContent === void 0 ? void 0 : domContent.classList.remove("invisible");
    const loginArea = document.getElementById("rudi-login");
    loginArea === null || loginArea === void 0 ? void 0 : loginArea.classList.add("disabled");
}
function styleHeader() {
    let domContent = document.getElementById("rudiProfileContainer");
    domContent === null || domContent === void 0 ? void 0 : domContent.classList.remove("invisible");
    domContent = document.getElementById("appNavigation");
    domContent === null || domContent === void 0 ? void 0 : domContent.classList.remove("invisible");
    domContent = document.getElementById("rudiHeader");
    domContent === null || domContent === void 0 ? void 0 : domContent.classList.remove("rudi-full-width");
}
function gotoUrl(event) {
    var _a;
    if (DEBUG)
        console.log("-->gotUrl", event);
    if (typeof event.attributes.targeturl.value != "undefined") {
        (_a = window.open(event.attributes.targeturl.value, '_blank')) === null || _a === void 0 ? void 0 : _a.focus();
    }
}
function addSearchBar(navNode, apps) {
    if (DEBUG)
        console.log('addSearchBar');
    const section = DomHelper.appendNode(navNode, 'section', ['top-search-bar-wrapper']);
    const inputNode = DomHelper.appendNode(section, 'div', ['top-search-bar'], [{ attr: 'contenteditable', value: 'true' }]);
    DomHelper.appendNode(section, 'i', ['fa-light', 'fa-search']);
    let debounceTimeout = null;
    inputNode.addEventListener('input', (event) => {
        var _a, _b;
        const searchTerm = event.target.innerText.trim().toLowerCase();
        if (debounceTimeout) {
            clearTimeout(debounceTimeout);
        }
        debounceTimeout = setTimeout(() => {
            if (logEvents)
                Util.logMessage(bearerToken, sessionid, "searchbar", "input", searchTerm);
        }, 300);
        let filteredApps = [];
        for (const appGroup of apps) {
            let filter = appGroup.children.filter(app => {
                var _a, _b;
                return app.odAppTitle.toLowerCase().includes(searchTerm) ||
                    ((_a = app.odAppSubTitle) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(searchTerm.toLowerCase())) ||
                    ((_b = app.odAppDescription) === null || _b === void 0 ? void 0 : _b.toLowerCase().includes(searchTerm.toLowerCase()));
            });
            filteredApps.push(...filter);
            if (appGroup.odAppTitle.toLowerCase().includes(searchTerm) ||
                ((_a = appGroup.odAppSubTitle) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(searchTerm.toLowerCase())) ||
                ((_b = appGroup.odAppDescription) === null || _b === void 0 ? void 0 : _b.toLowerCase().includes(searchTerm.toLowerCase()))) {
                filteredApps.push(appGroup);
            }
        }
        const activeNodes = document.querySelectorAll('.rudi-app');
        for (const app of activeNodes) {
            if (filteredApps.some(appInfo => appInfo.dn === app.getAttribute('ldap-dn'))) {
                app.classList.remove('disabled');
            }
            else {
                app.classList.add('disabled');
            }
        }
        DomHelper.updateCategoryVisibility('appGroups', 'rudi-app-group-header', 'rudi-app-group', 'rudi-app');
    });
}
function displayImpersonateClose() {
    const bodyNode = document.getElementById('rudi-body');
    if (bodyNode) {
        const usernameAdm = bodyNode.getAttribute('inp_by');
        const headerNode = bodyNode.querySelector('#rudiHeader');
        if (headerNode) {
            const messageNode = DomHelper.appendNodeBefore(headerNode, 'div', ['rudi-inpersonate'], [], 'Inpersonate aktiv');
            const buttonNode = DomHelper.appendNode(messageNode, 'button', ['btn', 'btn-primary', 'mt-2', 'ms-1',], [{
                    attr: 'id',
                    value: ''
                }]);
            DomHelper.appendNode(buttonNode, 'i', ['fa-light', 'fa-person-through-window', 'me-1'], []);
            DomHelper.appendNode(buttonNode, 'span', [], [], 'verlassen');
            buttonNode.addEventListener('click', function (event) {
                location.reload();
            });
        }
    }
}
export function renderSingleApp(response, currentNetwork, usernameImp) {
    const userResponse = JSON.parse(response.target.response);
    const deeplink = DomHelper.getHashValueFromUri(window);
    const appID = DomHelper.getAppIdFromDeepLink(deeplink);
    const app = Util.getAppByCN(userResponse, appID);
    const appConfig = JSON.parse(app.odAppConfig);
    const appendSection = document.getElementById('singleApp');
    if (!appendSection)
        return;
    appendSection.innerHTML = "";
    renderAppByType(app, currentNetwork, appendSection, userResponse, true);
    const appCard = appendSection.querySelector('.rudi-app-wrapper');
    if (appCard) {
        appCard.click();
        if (appConfig.fullscreen && appConfig.fullscreen === "true") {
            appendSection.classList.add("disabled");
        }
        if (appConfig.searchbar && appConfig.searchbar === "true") {
            DomHelper.add2DomElement("appNavigation", "");
            const navNode = document.getElementById("appNavigation");
            if (navNode)
                addSearchBar(navNode, userResponse.apps);
        }
    }
}
function addNetworkTag(currentNetwork) {
    const networkTag = document.getElementById('network-identifier');
    let networkName = "Internet";
    switch (currentNetwork) {
        case "zem-p1":
            networkName = "Citrix";
            break;
        case "zem-p2":
            networkName = "Client";
            break;
    }
    if (networkTag) {
        networkTag.innerHTML = networkName;
    }
}
export function render(response, usernameImp) {
    var _a, _b;
    let userResponse;
    let currentNetwork = "";
    if (DEBUG)
        console.log("-->Render", response);
    if (usernameImp) {
        if (DEBUG)
            console.log('entering inpersonate mode');
        username = usernameImp;
        displayImpersonateClose();
    }
    if (!response || !response.target || typeof response.target.response == "undefined") {
        if (DEBUG)
            console.log("using mockup json");
        userResponse = appDataMockup.odUserInfo;
    }
    else {
        userResponse = JSON.parse(response.target.response);
        currentNetwork = response.target.getResponseHeader('x-rudi-network');
    }
    let navContent = "";
    addNetworkTag(currentNetwork);
    if (window.location.host === "apps.rummelsberger.net" || window.location.host === "admpesapps.localhost" || window.location.host === "apps.localhost") {
        console.log("Using apps mode");
        renderSingleApp(response, currentNetwork, usernameImp);
        return;
    }
    userPreferences = userResponse.odDeskPreferences;
    if (DEBUG)
        console.log("Preferences from ldap", userPreferences);
    if (userPreferences.logInteraction)
        logEvents = true;
    if (logEvents)
        Util.logMessage(bearerToken, sessionid, "desk", "login", "null");
    const domNodeAppGroups = document.getElementById("appGroups");
    if (domNodeAppGroups == null) {
        console.log("Domelement appGroups not found, but necessary for the app to work");
        throw "Error getting appGroups";
    }
    if (DEBUG)
        console.log("userResponse.accessDenied", userResponse.accessDenied);
    const nameNode = document.getElementById('rudiProfile');
    if (nameNode)
        nameNode.innerHTML = `${userResponse.name} ${userResponse.surname}`;
    if (userResponse.accessDenied) {
        domNodeAppGroups.innerHTML = "";
        const infoSection = DomHelper.appendNode(domNodeAppGroups, 'section', [], []);
        DomHelper.appendNode(infoSection, 'h1', [], [], "RuDi#Desk wird gerade überarbeitet und steht nicht zur Verfügung!");
    }
    else {
        let selectedTheme = 'theme-default';
        if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
            selectedTheme = 'theme-dark';
        }
        if (!(((_a = userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.theme) === null || _a === void 0 ? void 0 : _a.length) > 2)) {
            if (userResponse.username.startsWith("gp")) {
                userPreferences.theme = 'theme-vielfalt';
                selectedTheme = 'theme-vielfalt';
                sendBackendData('', `/users/${username.toLowerCase()}/settings`, "PUT", 'application/json', bearerToken, userPreferences, (response) => {
                });
            }
        }
        else {
            selectedTheme = userPreferences.theme;
        }
        setTheme(selectedTheme, userPreferences, username, true);
        const [domNodeFavorites, domNodeFavoritesChildren] = addGroupFavorites(domNodeAppGroups, userResponse);
        window.scrollTo({ top: 0, left: 0 });
        const nestedGroups = [];
        for (let appgroup of userResponse.apps.sort((a, b) => a.odAppSortOrder - b.odAppSortOrder)) {
            if (DEBUG)
                console.log("working on", appgroup.cn);
            if (appgroup.odAppType != "[group]" && appgroup.odAppTitle != "Permissions") {
                renderAppGroup(userResponse, domNodeAppGroups, appgroup, domNodeFavorites, domNodeFavoritesChildren, currentNetwork);
                navContent += renderAppGroupNavigation(appgroup);
            }
            else {
                nestedGroups.push(appgroup);
            }
        }
        for (let appgroup of nestedGroups) {
            if (DEBUG)
                console.log("working on nested group", appgroup.cn);
            renderNestedAppGroup(username, userResponse, appgroup, domNodeFavorites, domNodeFavoritesChildren, currentNetwork);
        }
        styleHeader();
        enableThemeSwitcher();
        enableLogoutButton();
        DomHelper.add2DomElement("appNavigation", navContent);
        const navNode = document.getElementById("appNavigation");
        if (navNode)
            addSearchBar(navNode, userResponse.apps);
        addToggleGroupEvent(".rudi-app-group");
        let delay = 0;
        for (const message of userResponse.messages) {
            if ((_b = message.interaction) === null || _b === void 0 ? void 0 : _b.required) {
                const appNode = document.querySelector(`[ldap-dn="${message.appdn}"]`);
                if (appNode)
                    appNode.classList.add('disabledbymessage');
            }
            setTimeout(() => DomHelper.showMessage(message, username, bearerToken), delay);
            delay += 2500;
        }
        const deeplink = DomHelper.getHashValueFromUri(window);
        const appID = DomHelper.getAppIdFromDeepLink(deeplink);
        if (deeplink && !deeplink.startsWith('odapp_grp')) {
            DomHelper.clickAppById(document, appID);
        }
    }
}
if (!userLogoutTriggered) {
    init();
}
else {
}
